import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _styled from "styled-components";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { Button, Card, PrimaryCardHeader, Title } from '../../..';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ApplyConfirmation = function ApplyConfirmation(_ref) {
  var onProceedWithApplication = _ref.onProceedWithApplication,
      onChangeMind = _ref.onChangeMind,
      mainTitle = _ref.mainTitle,
      proceedButtonTitle = _ref.proceedButtonTitle,
      exitButtonTitle = _ref.exitButtonTitle,
      cardDetailAsChildren = _ref.children,
      loading = _ref.loading,
      restaurantPopupInfo = _ref.restaurantPopupInfo;

  var _useTranslation = useTranslation('onboarding-page'),
      t = _useTranslation.t;

  var companyReviewDetails = useMemo(function () {
    var _restaurantPopupInfo$, _restaurantPopupInfo$2, _restaurantPopupInfo$3;

    return restaurantPopupInfo ? {
      showRestaurant: true,
      companyLogo: '',
      seasonalAccommodation: false,
      companyName: (_restaurantPopupInfo$ = restaurantPopupInfo === null || restaurantPopupInfo === void 0 ? void 0 : restaurantPopupInfo.restaurantEmployerName) !== null && _restaurantPopupInfo$ !== void 0 ? _restaurantPopupInfo$ : '',
      title: (_restaurantPopupInfo$2 = restaurantPopupInfo === null || restaurantPopupInfo === void 0 ? void 0 : restaurantPopupInfo.restaurantName) !== null && _restaurantPopupInfo$2 !== void 0 ? _restaurantPopupInfo$2 : '',
      jobLocation: (_restaurantPopupInfo$3 = restaurantPopupInfo === null || restaurantPopupInfo === void 0 ? void 0 : restaurantPopupInfo.restaurantAddress) !== null && _restaurantPopupInfo$3 !== void 0 ? _restaurantPopupInfo$3 : '',
      jobLocality: '',
      fontColor: 'white'
    } : null;
  }, [restaurantPopupInfo]);
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [/*#__PURE__*/_jsx(Title, {
      content: mainTitle !== null && mainTitle !== void 0 ? mainTitle : t('youre_about_to_apply_spontaneously'),
      fontSize: "superLarge",
      fontWeight: "semibold",
      twStyle: {
        "textAlign": "center",
        "lineHeight": "1.75rem"
      }
    }), cardDetailAsChildren ? /*#__PURE__*/_jsx(_StyledDiv2, {
      children: cardDetailAsChildren
    }) : companyReviewDetails ? /*#__PURE__*/_jsx(Card, {
      twStyle: {
        "maxWidth": "20rem"
      },
      variant: "gradientBase",
      children: /*#__PURE__*/_jsx(PrimaryCardHeader, _objectSpread({}, _objectSpread(_objectSpread({}, companyReviewDetails), {}, {
        twStyle: {
          "marginTop": "0px"
        }
      })))
    }) : null, /*#__PURE__*/_jsxs(_StyledDiv3, {
      children: [/*#__PURE__*/_jsx(Button, {
        title: proceedButtonTitle !== null && proceedButtonTitle !== void 0 ? proceedButtonTitle : t('proceed_with_the_application'),
        variant: "normal",
        fullwidth: true,
        onClick: onProceedWithApplication,
        loading: loading
      }), /*#__PURE__*/_jsx(Button, {
        title: exitButtonTitle !== null && exitButtonTitle !== void 0 ? exitButtonTitle : t('changed_my_mind'),
        variant: "secondary-outline",
        fullwidth: true,
        onClick: onChangeMind
      })]
    })]
  });
};

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "apply-confirmation___StyledDiv",
  componentId: "sc-1uwc5xb-0"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "1rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "apply-confirmation___StyledDiv2",
  componentId: "sc-1uwc5xb-1"
})({
  "marginLeft": "auto",
  "marginRight": "auto",
  "marginTop": "2rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "apply-confirmation___StyledDiv3",
  componentId: "sc-1uwc5xb-2"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem",
  "paddingBottom": "1rem"
});